<template>
  <div class="notranslate flex w-[350px] flex-col rounded-t-md sm:w-[450px]" translate="no">
    <div v-for="item in marketplaces" :key="`marketplace-${item.code}`" class="flex h-[62px] items-center justify-between border-b first:rounded-t-md">
      <label :for="`marketplace-item-${item.code}`" class="v3-body-regular-400-line-height-auto radio-label notranslate flex-1 py-5 pl-4" translate="no">{{ item.name }}</label>
      <div class="shrink-0 py-5 pr-4">
        <RadioButton
          v-model="selected"
          :input-id="`marketplace-item-${item.code}`"
          name="pizza"
          :value="item"
        />
      </div>
    </div>
    <div class="flex items-center gap-2 px-4 py-5">
      <Button
        class="cancel-btn w-full"
        label="Cancel"
        severity="secondary"
        outlined
        @click="closeDialog"
      />
      <Button class="w-full" label="Select" @click="updateSelected" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import Button from 'primevue/button';
import RadioButton from 'primevue/radiobutton';
import { inject, onMounted, ref } from 'vue';

import type { DialogRef } from '@/types/global';
import type { Marketplace } from '@/types/marketplace';

const selected = ref<Marketplace>();

const dialogRef = inject<DialogRef>('dialogRef');
const marketplaces = ref<Marketplace[]>([]);

onMounted(() => {
  selected.value = dialogRef.value?.data.selectedMarketplace;
  marketplaces.value = dialogRef.value?.data.marketplaces;
});

const closeDialog = () => {
  dialogRef.value.close({
    action: 'cancel',
  });
};

const updateSelected = () => {
  dialogRef.value.close({
    action: 'select',
    selectedMarketplace: selected.value,
  });
};
</script>

<style lang="scss" scoped>
.radio-label {
    color: var(--next-text-on-light-primary, #69707A);
}
</style>
